<template>
  <div class="card">
    <div class="titleWrap">
      <div class="setTitle">IC卡列表</div>
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('read') > -1" @click="readCard" v-loading.fullscreen.lock="readLoading" element-loading-text="正在读卡..." style="margin-left: 10px;">读卡</el-button>
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('add') > -1" @click="add" v-loading.fullscreen.lock="writeLoading" element-loading-text="正在写卡...">写卡</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="villageValue" filterable size="small" placeholder="小区名称" v-if="villageId === ''">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
      <el-input class="input" v-model.trim="cardNumber" size="small" placeholder="卡号"></el-input>
      <el-select class="select" v-model="cardTypeValue" filterable clearable size="small" placeholder="卡片类型">
        <el-option v-for="item in cardTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-date-picker class="time" v-model="effectiveTime" size="small" type="daterange" :editable="false" range-separator="至" start-placeholder="有效日期" end-placeholder="有效日期"></el-date-picker>
      <el-select class="select" v-model="autoValue" filterable clearable size="small" placeholder="单层自动登记">
        <el-option v-for="item in autoList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="cardUser" size="small" placeholder="持卡人姓名"></el-input>
      <el-select class="select" v-model="userTypeValue" filterable clearable size="small" placeholder="用户类型">
        <el-option v-for="item in userTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-date-picker class="time" v-model="openCardTime" size="small" type="daterange" :editable="false" range-separator="至" start-placeholder="开卡日期" end-placeholder="开卡日期"></el-date-picker>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="cardAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="orgName" label="小区名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="cardNum" label="卡号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="cardType" label="卡片类型" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ getCardType(scope.row.cardType) }}
          </template>
        </el-table-column>
        <el-table-column prop="expireDate" label="有效期" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ myTime(scope.row.expireDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="workTime" label="有效时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.workTime }}
          </template>
        </el-table-column>
        <el-table-column prop="allowTimes" label="允许刷卡(次)" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.allowTimes) }}
          </template>
        </el-table-column>
        <el-table-column prop="auth" label="单层自动登记" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="autho open" v-if="scope.row.auth === 1"></div>
            <div class="autho close" v-if="scope.row.auth === 0"></div>
            {{ getAutho(scope.row.auth) }}
          </template>
        </el-table-column>
        <el-table-column prop="userType" label="用户类型" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="userType owner" v-if="scope.row.userType === 0"></div>
            <div class="userType propClean" v-if="scope.row.userType === 4"></div>
            {{ getOwnerType(scope.row.userType) }}
          </template>
        </el-table-column>
        <el-table-column prop="owner" label="持卡人姓名" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="createDate" label="开卡日期" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ myTime(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" @click="remove(scope.row.id, scope.row.ownerId, scope.row.cardNum, scope.row.userType)">删除</el-button>
            <el-button type="text" size="small" v-if="funcData.indexOf('detail') > -1" :disabled="scope.row.userType !== 0" @click="detail(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="cardCurr" :page-sizes="[10, 20, 50]" :page-size="cardSize" :total="cardTotal" @current-change="cardCurrChange" @size-change="cardSizeChange"></el-pagination>
    </el-main>
    <!-- 新增IC卡弹出层 -->
    <el-dialog :visible.sync="cardDialog" :title="cardTitle" width="500px" :close-on-click-modal="false" @close="cardNotBtn">
      <el-form ref="cardForm" :model="cardForm" :rules="cardRules" label-width="120px" size="small">
        <el-form-item label="写卡器终端" prop="cardSN">
          <el-input v-model.trim="cardForm.cardSN" disabled placeholder="写卡器终端"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="cardStatus">
          <el-input v-model.trim="cardForm.cardStatus" disabled placeholder="状态"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType">
          <el-select class="select" v-model="cardForm.userType" filterable clearable size="small" placeholder="用户类型" @change="changeUserType">
            <el-option v-for="item in cardForm.userTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="持卡者" prop="user">
          <el-select class="select" v-model="cardForm.user" filterable clearable size="small" placeholder="持卡者" @change="changeUser">
            <el-option v-for="item in cardForm.userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号" prop="cardNum">
          <el-input v-model.trim="cardForm.cardNum" disabled placeholder="卡号"></el-input>
        </el-form-item>
        <el-form-item label="卡片类型" prop="cardType">
          <el-select class="select" v-model="cardForm.cardType" filterable clearable size="small" :disabled="cardForm.cardTypeStatus" placeholder="卡片类型" @change="changeCardType">
            <el-option v-for="item in cardForm.cardTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="允许刷卡次数" prop="allowTimes" v-if="cardForm.cardType !== 1 && cardForm.cardType !== 5 && cardForm.cardType !== ''">
          <el-input v-model.trim.number="cardForm.allowTimes" placeholder="允许刷卡次数"></el-input>
        </el-form-item>
        <el-form-item label="卡片有效期" prop="activeTime">
          <el-date-picker type="daterange" v-model="cardForm.activeTime" :editable="false" range-separator="至" start-placeholder="生效期" end-placeholder="失效期" :picker-options="setMinTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效时间" prop="workTime">
          <el-time-picker is-range v-model="cardForm.workTime" :editable="false" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择有效时间"></el-time-picker>
        </el-form-item>
        <el-form-item label="单层自动登记" prop="autho">
          <el-radio-group v-model="cardForm.autho">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="可乘电梯" :required="true" v-show="!cardForm.isType5"></el-form-item>
        <el-table ref="liftList" :data="cardForm.roomAttr" class="list" @selection-change="selectRoom" v-show="!cardForm.isType5">
          <el-table-column type="selection" width="55" :align="align"></el-table-column>
          <el-table-column prop="building" label="楼号" min-width="80" :align="align">
            <template slot-scope="scope">
              {{ scope.row.building }}栋
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单元号" min-width="80" :align="align">
            <template slot-scope="scope">
              {{ scope.row.unit }}单元
            </template>
          </el-table-column>
          <el-table-column prop="room" label="房号" min-width="180" :align="align">
            <template slot-scope="scope">
              {{ notData(scope.row.room) }}
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cardNotBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="cardLoading" @click="cardOkBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 读卡弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="820px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="cardDetail" size="small">
        <el-form-item class="myItem">
          <el-col :span="8">
            <span class="title">小区号：</span>
            <span class="content">{{ notData(cardDetail.communityNumber) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">卡号：</span>
            <span class="content">{{ notData(cardDetail.cardNumber) }}</span>
          </el-col>
        </el-form-item>
        <el-form-item class="myItem">
          <el-col :span="8">
            <span class="title">终端序列号：</span>
            <span class="content">{{ notData(cardDetail.cardSN) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">写卡器扇区：</span>
            <span class="content">{{ notData(cardDetail.cardSector) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">写卡器状态：</span>
            <span class="content">{{ notData(cardDetail.cardStatus) }}</span>
          </el-col>
        </el-form-item>
        <el-form-item class="myItem">
          <el-col :span="8">
            <span class="title">卡片类型：</span>
            <span class="content">{{ notData(cardDetail.cardType) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">卡片截止期：</span>
            <span class="content">{{ notData(cardDetail.cardExpiredDate) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">卡片有效时间：</span>
            <span class="content">{{ notData(cardDetail.executeTime) }}</span>
          </el-col>
        </el-form-item>
        <el-form-item class="myItem">
          <el-col :span="8">
            <span class="title">允许刷卡次数：</span>
            <span class="content">{{ notData(cardDetail.cardAllowTimes) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">实际刷卡次数：</span>
            <span class="content">{{ notData(cardDetail.realTimes) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">单层自动登记：</span>
            <span class="content">{{ notData(cardDetail.cardAuto) }}</span>
          </el-col>
        </el-form-item>
        <el-form-item class="myItem">
          <el-col :span="8">
            <span class="title">用户：</span>
            <span class="content">{{ notData(cardDetail.userName) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">用户类型：</span>
            <span class="content">{{ notData(cardDetail.userType) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">卡片状态：</span>
            <span class="content" v-if="cardDetail.status === 1">启用</span>
            <span class="content" v-if="cardDetail.status === -1">停用</span>
          </el-col>
        </el-form-item>
        <el-form-item class="myItem" v-for="(item, index) in cardDetail.liftList" :key="index">
          <el-col :span="8">
            <span class="title">电梯组号{{ index + 1 }}：</span>
            <span class="content">{{ notData(item.liftNumber) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">楼层{{ index + 1 }}：</span>
            <span class="content">{{ notData(item.floor) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="title">前/后门：</span>
            <span class="content">{{ notData(item.door) }}</span>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" v-if="cardDetail.status === 1 && isVillage" @click="edit(cardDetail.id, cardDetail.cardNumber)">编 辑</el-button>
        <el-button size="small" type="primary" v-if="cardDetail.status === 1 && isVillage" @click="remove(cardDetail.id, cardDetail.ownerId, cardDetail.cardNumber, cardDetail.userType)">删 卡</el-button>
      </span>
    </el-dialog>
    <!-- IC卡详情弹出层 -->
    <el-dialog :visible.sync="detailDialog" :title="detailTitle" width="500px" :close-on-click-modal="false" @close="detailNotBtn">
      <el-table ref="detailList" :data="detailList" class="list">
        <el-table-column prop="building" label="楼号" min-width="80" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元号" min-width="80" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
        <el-table-column prop="room" label="房号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.room) }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailNotBtn">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mqtt from '../../utils/mqtt.js'

export default {
  name: 'Card',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      setMinTime: { // 日期大于当前
        disabledDate: time => {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      readLoading: false, // 读卡全局loading
      writeLoading: false, // 写卡全局loading
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      cardNumber: '', // 卡号查询输入框
      cardTypeValue: '', // 卡片类型下拉菜单选中value
      cardTypeList: [], // 卡片类型下拉菜单
      effectiveTime: '', // 有效日期查询输入框
      autoValue: '', // 单层自动登记下拉菜单选中value
      autoList: [], // 单层自动登记下拉菜单
      cardUser: '', // 持卡人姓名查询输入框
      userTypeValue: '', // 用户类型下拉菜单选中value
      userTypeList: [], // 用户类型下拉菜单
      openCardTime: '', // 开卡日期查询输入框
      cardAttr: [], //  IC卡列表
      cardTotal: 0, //  IC卡总数
      cardSize: 10, //  IC卡每页条数
      cardCurr: 1, //  IC卡当前页数
      cardDialog: false, // IC卡弹出层状态
      cardTitle: '', // IC卡弹出层标题
      cardLoading: false, // IC卡弹出层确定按钮loading
      tempCard: '', // 临时卡号字段
      tempSN: '', // 临时SN字段
      cardForm: {
        id: '', // IC卡Id
        cardSN: '', // 写卡器终端
        cardStatus: '', // 状态
        cardSection: '', // 扇区
        userType: '', // 用户类型
        userTypeList: [], // 用户类型下拉框
        user: '', // 持卡者
        userList: [], // 持卡者下拉框
        cardNum: '', // 卡号
        cardTypeStatus: false, // 卡片类型下拉框状态
        cardType: '', // 卡片类型
        cardTypeList: [], // 卡片类型下拉框
        allowTimes: '', // 允许刷卡次数
        activeTime: '', // 卡片有效期
        autho: '', // 单层自动登记
        workTime: '', // 有效时间
        roomAttr: [], // 房间列表
        selectRoomArr: [], // 选中的房间数组
        isType5: false // 是否为通卡
      },
      cardRules: {
        cardSN: [
          {
            required: true,
            message: '写卡器终端为空',
            trigger: ['blur', 'change']
          }
        ],
        cardStatus: [
          {
            required: true,
            message: '状态为空',
            trigger: ['blur', 'change']
          }
        ],
        userType: [
          {
            required: true,
            message: '请选择用户类型',
            trigger: 'change'
          }
        ],
        user: [
          {
            required: true,
            message: '请选择持卡者',
            trigger: 'change'
          }
        ],
        cardNum: [
          {
            required: true,
            message: '卡号为空',
            trigger: ['blur', 'change']
          }
        ],
        cardType: [
          {
            required: true,
            message: '请选择卡片类型',
            trigger: 'change'
          }
        ],
        allowTimes: [
          {
            required: true,
            message: '请输入允许刷卡次数',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            message: '允许刷卡次数必须为数字值',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value < 1 || value > 65535) {
                callback(new Error('允许刷卡次数范围是1~65535'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        activeTime: [
          {
            required: true,
            message: '请选择卡片有效期',
            trigger: 'change'
          }
        ],
        autho: [
          {
            required: true,
            message: '请选择单层自动登记',
            trigger: 'change'
          }
        ],
        workTime: [
          {
            required: true,
            message: '请选择有效时间',
            trigger: 'change'
          }
        ]
      },
      dialog: false, // 读卡弹出层状态
      title: '读卡信息', // 读卡弹出层标题
      cardDetail: {
        id: '', // IC卡Id
        communityNumber: '', // 小区号
        cardNumber: '', // 卡号
        cardStatus: '', // 写卡器状态
        cardSN: '', // 写卡器终端序列号
        cardSector: '', // 写卡器扇区
        cardType: '', // 卡片类型
        cardExpiredDate: '', // 卡片截止期
        executeTime: '', // 卡片有效时间
        cardAllowTimes: '', // 允许刷卡次数
        realTimes: '', // 实际已刷卡次数
        cardAuto: '', // 单层自动登记
        ownerId: '', // 用户Id
        userName: '', // 用户
        userCard: '', // 身份证号
        userType: '', // 用户类型
        status: '', // 卡片状态
        liftList: [] // 电梯列表
      },
      cardDel: {
        ownerId: '', // 删卡时的用户Id
        cardNum: '', // 删卡时的卡号
        userType: '', // 删卡时的用户类型
        cardType: '', // 删卡时的IC卡类型
        liftParams: {}, // 删卡时的终端EMQ基本参数
        cardParams: {} // 删卡时的写卡器EMQ基本参数
      },
      isVillage: false, // 是否为本小区
      detailDialog: false, // IC卡详情弹出层状态
      detailTitle: 'IC卡详情', // IC卡详情弹出层标题
      detailList: [], // IC卡详情列表
      liftNumberRuleObj: {}, // 电梯组号的规则明细
      emqTime: null, // emq超时定时器
      client: null, // MQTT对象
      host: this.$host, // MQTT地址
      port: this.$port, // MQTT地址端口号
      clientId: 'WEB:' + new Date().getTime().toString(), // MQTT对象Id，当前时间
      username: this.$store.state.user.username, // MQTT访问的用户名
      password: this.$store.state.user.password // MQTT访问的密码
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }

    // 获取小区名称下拉菜单
    this.$http.get(this.$api.village_list, {
      params: {
        pageSize: 9999,
        pageNum: 1
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.villageValue = data.data.list[0].id
        this.villageList = data.data.list

        // 获取IC卡列表
        this.getCardList(this.cardCurr, this.cardSize)
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取卡片类型下拉框数据
    this.cardTypeList = [
      {
        key: 1,
        value: '乘梯卡不计次数'
      },
      {
        key: 2,
        value: '乘梯卡计次数'
      },
      {
        key: 3,
        value: '用户保密切换卡'
      },
      {
        key: 4,
        value: 'VIP卡'
      },
      {
        key: 5,
        value: '通卡'
      },
      {
        key: 6,
        value: '备用'
      }
    ]
    // 获取单层自动登记下拉框数据
    this.autoList = [
      {
        key: 0,
        value: '关闭'
      },
      {
        key: 1,
        value: '开启'
      }
    ]
    // 获取用户类型下拉框数据
    this.userTypeList = [
      {
        key: 0,
        value: '业主'
      },
      {
        key: 4,
        value: '物业保洁'
      }
    ]
    this.cardForm.userTypeList = [
      {
        key: 0,
        value: '业主'
      },
      {
        key: 4,
        value: '物业保洁'
      }
    ]
    // 获取电梯组号的规则明细
    this.$http.get(this.$api.lift_num_rule).then((res) => {
      let data = res.data

      if (data.success) {
        this.liftNumberRuleObj = data.data
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  methods: {
    getCardList (page, size) {
      let params
      let startExpireDate = ''
      let endExpireDate = ''
      let startDate = ''
      let endDate = ''
      if (this.effectiveTime !== '' && this.effectiveTime !== null) {
        var date = this.effectiveTime[1]
        date = date.setDate(date.getDate() + 1)
        startExpireDate = this.$date1(this.effectiveTime[0].toString())
        endExpireDate = this.$date3(date)
      }
      if (this.openCardTime !== '' && this.openCardTime !== null) {
        startDate = this.$date1(this.openCardTime[0].toString())
        endDate = this.$date1(this.openCardTime[1].toString())
      }
      if (this.villageId === '') {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageValue,
          cardNum: this.cardNumber,
          cardType: this.cardTypeValue,
          expireStartDate: startExpireDate,
          expireEndDate: endExpireDate,
          auth: this.autoValue,
          userType: this.userTypeValue,
          owner: this.cardUser,
          createStartDate: startDate,
          createEndDate: endDate
        }
      } else {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId,
          cardNum: this.cardNumber,
          cardType: this.cardTypeValue,
          expireStartDate: startExpireDate,
          expireEndDate: endExpireDate,
          auth: this.autoValue,
          userType: this.userTypeValue,
          owner: this.cardUser,
          createStartDate: startDate,
          createEndDate: endDate
        }
      }
      this.$http.get(this.$api.card_list, {
        params: params
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.cardAttr = data.data.list
          this.cardTotal = data.data.total
          this.cardSize = size
          this.cardCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getCardList(1, this.cardSize)
    },
    add () {
      this.$http.get(this.$api.card_number).then((res) => {
        let data = res.data
        let cardNum = ''

        if (data.success) {
          cardNum = data.data.data

          this.$http.get(this.$api.writer_info, {
            params: {
              orgId: this.villageId
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.cardForm.cardNum = cardNum
              this.cardForm.cardSN = data.data.writer
              if (data.data.online) {
                this.cardForm.cardStatus = '在线'
              } else {
                this.cardForm.cardStatus = '离线'
              }
              this.cardForm.cardSection = data.data.sector
              this.cardTitle = '新增IC卡'
              this.cardDialog = true
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    edit (id, cardNum) {
      this.$http.get(this.$api.user_card_info, {
        params: {
          orgId: this.villageId,
          cardNum: cardNum
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          let roomArr = data.data.rooms.split(',')
          this.cardForm.id = id
          this.cardForm.userType = data.data.userType
          this.changeUserType(this.cardForm.userType)
          this.cardForm.user = data.data.ownerId
          if (this.cardForm.userType === 0) {
            // 获取业主详情数据
            this.$http.get(this.$api.owner_detail_card, {
              params: {
                ownerId: this.cardForm.user
              }
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.cardForm.roomAttr = []
                // 展示当前小区房间
                for (let i = 0; i < data.data.data.length; i++) {
                  if (data.data.data[i].orgId === this.villageId) {
                    this.cardForm.roomAttr.push(data.data.data[i])
                  }
                }
                // 对比楼栋单元来展示已勾选的房间
                for (let i = 0; i < this.cardForm.roomAttr.length; i++) {
                  for (let j = 0; j < roomArr.length; j++) {
                    let myRoom = this.cardForm.roomAttr[i].building + '-' + this.cardForm.roomAttr[i].unit + '-' + this.cardForm.roomAttr[i].room
                    if (myRoom === roomArr[j]) {
                      this.cardForm.selectRoomArr.push(this.cardForm.roomAttr[i])
                    }
                  }
                }
                setTimeout(() => {
                  this.cardForm.selectRoomArr.forEach(row => {
                    this.$refs.liftList.toggleRowSelection(row, true)
                  })
                }, 1000)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.cardForm.userType === 4) {
            // 获取物业保洁详情数据
            this.$http.get(this.$api.orgmanager_building_detail, {
              params: {
                id: this.cardForm.user
              }
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.cardForm.roomAttr = data.data.data
                // 对比楼栋单元来展示已勾选的房间
                for (let i = 0; i < this.cardForm.roomAttr.length; i++) {
                  for (let j = 0; j < roomArr.length; j++) {
                    let myRoom = this.cardForm.roomAttr[i].building + '-' + this.cardForm.roomAttr[i].unit
                    if (myRoom === roomArr[j]) {
                      this.cardForm.selectRoomArr.push(this.cardForm.roomAttr[i])
                    }
                  }
                }
                setTimeout(() => {
                  this.cardForm.selectRoomArr.forEach(row => {
                    this.$refs.liftList.toggleRowSelection(row, true)
                  })
                }, 1000)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          this.cardForm.cardType = data.data.cardType
          if (this.cardForm.cardType === 5) {
            this.cardForm.isType5 = true
          }
          if (data.data.allowTimes === null) {
            this.cardForm.allowTimes = ''
          } else {
            this.cardForm.allowTimes = data.data.allowTimes
          }
          this.cardForm.autho = data.data.auth
          this.cardForm.activeTime = [new Date(data.data.effectiveDate), new Date(data.data.expireDate)]
          this.cardForm.workTime = [new Date(2020, 10, 10, Number(data.data.workTime.substr(0, 2)), Number(data.data.workTime.substr(3, 2))), new Date(2020, 10, 10, Number(data.data.workTime.substr(6, 2)), Number(data.data.workTime.substr(9, 2)))]

          this.$http.get(this.$api.writer_info, {
            params: {
              orgId: this.villageId
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.cardForm.cardNum = cardNum
              this.cardForm.cardSN = data.data.writer
              if (data.data.online) {
                this.cardForm.cardStatus = '在线'
              } else {
                this.cardForm.cardStatus = '离线'
              }
              this.cardForm.cardSection = data.data.sector
              this.cardTitle = '编辑IC卡'
              this.cardDialog = true
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    remove (id, ownerId, cardNum, userType) {
      this.$confirm('是否删除IC卡?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cardDel.ownerId = ownerId
        this.cardDel.cardNum = cardNum
        this.cardDel.userType = userType

        this.$http.get(this.$api.user_card_info, {
          params: {
            orgId: this.villageId,
            cardNum: cardNum
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            // 终端EMQ基本参数
            this.cardDel.liftParams = {
              EffectiveTime: data.data.effectiveDate.substr(0, 4) + data.data.effectiveDate.substr(5, 2) + data.data.effectiveDate.substr(8, 2) + '0000',
              ExpiredDate: data.data.expireDate.substr(0, 4) + data.data.expireDate.substr(5, 2) + data.data.expireDate.substr(8, 2) + '2359',
              ExecuteTime: data.data.workTime.substr(0, 2) + data.data.workTime.substr(3, 2) + '-' + data.data.workTime.substr(6, 2) + data.data.workTime.substr(9, 2),
              OperationType: 2, // IC卡删除
              singleFloorAutoRegistration: Number(data.data.auth),
              Type: Number(data.data.cardType),
              Number: data.data.cardNum,
              communityNumber: this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(0, 3)).toString(16)) + this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(3, 3)).toString(16)) + this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(6, 3)).toString(16))
            }
            // 写卡器EMQ基本参数
            this.cardDel.cardParams = {
              cardNumber: data.data.cardNum,
              communityNumber: this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(0, 3)).toString(16)) + this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(3, 3)).toString(16)) + this.set10to16String(Number(this.$store.state.user.dlevelcode.substr(6, 3)).toString(16)),
              cardType: Number(data.data.cardType),
              cardExpiredDate: data.data.expireDate.substr(0, 4) + data.data.expireDate.substr(5, 2) + data.data.expireDate.substr(8, 2),
              cardExecuteTime: data.data.workTime.substr(0, 2) + data.data.workTime.substr(3, 2) + '-' + data.data.workTime.substr(6, 2) + data.data.workTime.substr(9, 2),
              singleFloorAutoRegistration: data.data.auth
            }
            if (data.data.allowTimes !== null) {
              this.cardDel.liftParams.AllowTimes = data.data.allowTimes
              this.cardDel.cardParams.cardAllowTimes = data.data.allowTimes
            } else {
              this.cardDel.liftParams.AllowTimes = 65535
              this.cardDel.cardParams.cardAllowTimes = 65535
            }
            this.cardDel.cardType = data.data.cardType

            let formData = new FormData()
            formData.append('id', id)

            this.$http({
              method: 'post',
              url: this.$api.card_delete,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: 'IC卡已删除',
                  type: 'success',
                  duration: 1000
                })
                this.cardDel.liftParams.AvertCopyNum = mqtt.getSecondForQrcode(data.data)
                this.cardDel.cardParams.AvertCopyNum = mqtt.getSecondForQrcode(data.data)
                this.getCardList(1, this.cardSize)
                this.onConnectDel()
                this.notBtn()
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    detailNotBtn () {
      this.detailDialog = false
      this.detailList = []
    },
    detail (id) {
      this.$http.get(this.$api.card_detail, {
        params: {
          cardId: id
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.detailList = data.data.data
          this.detailDialog = true
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectDel () {
      if (this.cardDel.userType === '业主' || this.cardDel.userType === 0) {
        // 获取业主详情数据
        this.$http.get(this.$api.owner_detail_card, {
          params: {
            ownerId: this.cardDel.ownerId
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            let items = [] // MQ消息体数组
            for (let i = 0; i < data.data.data.length; i++) {
              for (let j = 0; j < data.data.data[i].json.sn.length; j++) {
                let pubLiftTopic = '/TYPE01/' + data.data.data[i].json.sn[j] + '/info'
                let myParams = this.cardDel.liftParams

                if (data.data.data[i].json.groupNum.length === 1) {
                  myParams.GroupNum = '00' + data.data.data[i].json.groupNum
                } else if (data.data.data[i].json.groupNum.length === 2) {
                  myParams.GroupNum = '0' + data.data.data[i].json.groupNum
                } else if (data.data.data[i].json.groupNum.length === 3) {
                  myParams.GroupNum = data.data.data[i].json.groupNum
                }
                let myLiftSend = {
                  cmd: 'downIcInfo',
                  params: myParams
                }
                items.push({
                  topic: pubLiftTopic,
                  mqttJson: JSON.stringify(myLiftSend)
                })
              }
              // 判断是否为当前小区
              if (data.data.data[i].orgId === this.villageId) {
                for (let j = 0; j < data.data.data[i].json.gate.length; j++) {
                  let pubLiftTopic = '/TYPE03/' + data.data.data[i].json.gate[j] + '/info'
                  let myParams = this.cardDel.liftParams

                  if (data.data.data[i].json.groupNum.length === 1) {
                    myParams.GroupNum = '00' + data.data.data[i].json.groupNum
                  } else if (data.data.data[i].json.groupNum.length === 2) {
                    myParams.GroupNum = '0' + data.data.data[i].json.groupNum
                  } else if (data.data.data[i].json.groupNum.length === 3) {
                    myParams.GroupNum = data.data.data[i].json.groupNum
                  }
                  let myLiftSend = {
                    cmd: 'downIcInfo',
                    params: myParams
                  }
                  items.push({
                    topic: pubLiftTopic,
                    mqttJson: JSON.stringify(myLiftSend)
                  })
                }
              }
            }
            // 去重（相同的SN、网关）
            for (let i = 0; i < items.length; i++) {
              for (let j = i + 1; j < items.length; j++) {
                if (items[i].topic === items[j].topic) {
                  items.splice(j, 1)
                  j--
                }
              }
            }
            this.$http({
              method: 'post',
              url: this.$api.mqtt_push,
              data: {
                items: items
              }
            }).then((res) => {
              let data = res.data
              if (!data.success) {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.cardDel.userType === '物业保洁' || this.cardDel.userType === 4) {
        // 获取物业保洁详情数据
        if (this.cardDel.cardType === 5) {
          // 获取所有小区读头
          this.$http.get(this.$api.lift_allSN, {
            params: {
              orgId: this.villageId
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              let myLiftList = data.data
              let items = [] // MQ消息体数组

              for (let i = 0; i < myLiftList.length; i++) {
                if (myLiftList[i].sn !== null) {
                  let pubLiftTopic = '/TYPE01/' + myLiftList[i].sn + '/info'
                  let myParams = this.cardDel.liftParams
                  if (myLiftList[i].liftNum.length === 1) {
                    myParams.GroupNum = '00' + myLiftList[i].liftNum
                  } else if (myLiftList[i].liftNum.length === 2) {
                    myParams.GroupNum = '0' + myLiftList[i].liftNum
                  } else if (myLiftList[i].liftNum.length === 3) {
                    myParams.GroupNum = myLiftList[i].liftNum
                  }
                  let myLiftSend = {
                    cmd: 'downIcInfo',
                    params: myParams
                  }
                  items.push({
                    topic: pubLiftTopic,
                    mqttJson: JSON.stringify(myLiftSend)
                  })
                }
              }
              this.$http({
                method: 'post',
                url: this.$api.mqtt_push,
                data: {
                  items: items
                }
              }).then((res) => {
                let data = res.data
                if (!data.success) {
                  this.$message({
                    type: 'error',
                    message: data.msg,
                    duration: 1000
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
          // 获取所有小区网关
          this.$http.get(this.$api.lift_allGate, {
            params: {
              orgId: this.villageId
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              let myLiftList = data.data
              let items = [] // MQ消息体数组

              for (let i = 0; i < myLiftList.length; i++) {
                if (myLiftList[i].gateway !== null) {
                  let pubLiftTopic = '/TYPE03/' + myLiftList[i].gateway + '/info'
                  let myParams = this.cardDel.liftParams
                  if (myLiftList[i].liftNum.length === 1) {
                    myParams.GroupNum = '00' + myLiftList[i].liftNum
                  } else if (myLiftList[i].liftNum.length === 2) {
                    myParams.GroupNum = '0' + myLiftList[i].liftNum
                  } else if (myLiftList[i].liftNum.length === 3) {
                    myParams.GroupNum = myLiftList[i].liftNum
                  }
                  let myLiftSend = {
                    cmd: 'downIcInfo',
                    params: myParams
                  }
                  items.push({
                    topic: pubLiftTopic,
                    mqttJson: JSON.stringify(myLiftSend)
                  })
                }
              }
              this.$http({
                method: 'post',
                url: this.$api.mqtt_push,
                data: {
                  items: items
                }
              }).then((res) => {
                let data = res.data
                if (!data.success) {
                  this.$message({
                    type: 'error',
                    message: data.msg,
                    duration: 1000
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.$http.get(this.$api.orgmanager_building_detail, {
            params: {
              id: this.cardDel.ownerId
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              let items = [] // MQ消息体数组
              for (let i = 0; i < data.data.data.length; i++) {
                for (let j = 0; j < data.data.data[i].json.sn.length; j++) {
                  let pubLiftTopic = '/TYPE01/' + data.data.data[i].json.sn[j] + '/info'
                  let myParams = this.cardDel.liftParams

                  if (data.data.data[i].json.groupNum.length === 1) {
                    myParams.GroupNum = '00' + data.data.data[i].json.groupNum
                  } else if (data.data.data[i].json.groupNum.length === 2) {
                    myParams.GroupNum = '0' + data.data.data[i].json.groupNum
                  } else if (data.data.data[i].json.groupNum.length === 3) {
                    myParams.GroupNum = data.data.data[i].json.groupNum
                  }
                  let myLiftSend = {
                    cmd: 'downIcInfo',
                    params: myParams
                  }
                  items.push({
                    topic: pubLiftTopic,
                    mqttJson: JSON.stringify(myLiftSend)
                  })
                }
                // 判断是否为当前小区
                if (data.data.data[i].orgId === this.villageId) {
                  for (let j = 0; j < data.data.data[i].json.gate.length; j++) {
                    let pubLiftTopic = '/TYPE03/' + data.data.data[i].json.gate[j] + '/info'
                    let myParams = this.cardDel.liftParams

                    if (data.data.data[i].json.groupNum.length === 1) {
                      myParams.GroupNum = '00' + data.data.data[i].json.groupNum
                    } else if (data.data.data[i].json.groupNum.length === 2) {
                      myParams.GroupNum = '0' + data.data.data[i].json.groupNum
                    } else if (data.data.data[i].json.groupNum.length === 3) {
                      myParams.GroupNum = data.data.data[i].json.groupNum
                    }
                    let myLiftSend = {
                      cmd: 'downIcInfo',
                      params: myParams
                    }
                    items.push({
                      topic: pubLiftTopic,
                      mqttJson: JSON.stringify(myLiftSend)
                    })
                  }
                }
              }
              // 去重（相同的SN、网关）
              for (let i = 0; i < items.length; i++) {
                for (let j = i + 1; j < items.length; j++) {
                  if (items[i].topic === items[j].topic) {
                    items.splice(j, 1)
                    j--
                  }
                }
              }
              this.$http({
                method: 'post',
                url: this.$api.mqtt_push,
                data: {
                  items: items
                }
              }).then((res) => {
                let data = res.data
                if (!data.success) {
                  this.$message({
                    type: 'error',
                    message: data.msg,
                    duration: 1000
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
      // 获取写卡器终端序列号、扇区
      this.$http.get(this.$api.writer_info, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data
        if (data.success) {
          this.cardDel.cardParams.sector = data.data.sector
          let items = [] // MQ消息体数组
          let pubLiftTopic = '/TYPE02/' + data.data.writer + '/info'
          let myParams = this.cardDel.cardParams
          let myLiftSend = {
            cmd: 'writeCard',
            params: myParams
          }
          items.push({
            topic: pubLiftTopic,
            mqttJson: JSON.stringify(myLiftSend)
          })
          this.$http({
            method: 'post',
            url: this.$api.mqtt_push2,
            data: {
              items: items
            }
          }).then((res) => {
            let data = res.data
            if (!data.success) {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    readCard () {
      this.$http.get(this.$api.writer_info, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          if (data.data.online) {
            this.cardDetail.cardStatus = '在线'
          } else {
            this.cardDetail.cardStatus = '离线'
          }
          this.cardDetail.cardSN = this.$null(data.data.writer)
          this.cardDetail.cardSector = this.$null(data.data.sector)

          this.client = new window.Paho.MQTT.Client(this.host, Number(this.port), this.clientId)
          let options = {
            invocationContext: {
              host: this.host,
              port: this.port,
              path: this.client.path,
              clientId: this.clientId
            },
            useSSL: this.$useSSL,
            timeout: 10,
            keepAliveInterval: 60,
            cleanSession: true,
            userName: this.username,
            password: this.password,
            onSuccess: this.onConnectRead,
            onFailure: this.onFailure
          }
          this.client.connect(options)
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectRead () {
      console.log('连接成功')
      this.readLoading = true
      let flag = true // 连接状态

      this.emqTime = setTimeout(() => {
        this.readLoading = false
        clearTimeout(this.emqTime)
        flag = false
        this.$message({
          type: 'error',
          message: '连接超时',
          duration: 1000
        })
      }, 10000)

      let params = {
        sector: this.cardDetail.cardSector
      }
      let subTopic = '/TYPE02/' + this.cardDetail.cardSN + '/reply'
      let pubTopic = '/TYPE02/' + this.cardDetail.cardSN + '/info'
      let mySend = {
        cmd: 'readCard',
        params: params
      }
      this.client.subscribe(subTopic, { qos: 1 })
      let message = new window.Paho.MQTT.Message(JSON.stringify(mySend))
      message.destinationName = pubTopic
      message.qos = 1
      message.retained = false
      this.client.send(message)

      this.client.onMessageArrived = (res) => {
        this.readLoading = false
        clearTimeout(this.emqTime)
        let data = JSON.parse(res.payloadString)
        console.log(data)
        if (flag) {
          if (data.cmd === 'readResult') {
            if (data.params.result === 1) {
              let liftLen = 0 // 电梯数量

              this.cardDetail.communityNumber = this.set16to10String(parseInt(data.params.communityNumber.substr(0, 2), 16).toString()) + ' ' + this.set16to10String(parseInt(data.params.communityNumber.substr(2, 2), 16).toString()) + ' ' + this.set16to10String(parseInt(data.params.communityNumber.substr(4, 2), 16).toString())
              this.cardDetail.cardNumber = data.params.cardNumber
              switch (data.params.cardType) {
                case 1:
                  this.cardDetail.cardType = '乘梯卡不计次数'
                  break
                case 2:
                  this.cardDetail.cardType = '乘梯卡计次数'
                  break
                case 3:
                  this.cardDetail.cardType = '用户保密切换卡'
                  break
                case 4:
                  this.cardDetail.cardType = 'VIP卡'
                  break
                case 5:
                  this.cardDetail.cardType = '通卡'
                  break
                case 6:
                  this.cardDetail.cardType = '备用'
                  break
              }
              this.cardDetail.cardExpiredDate = data.params.cardExpiredDate.substr(0, 4) + '-' + data.params.cardExpiredDate.substr(4, 2) + '-' + data.params.cardExpiredDate.substr(6, 2)
              this.cardDetail.executeTime = data.params.cardExpiredTime.substr(0, 2) + ':' + data.params.cardExpiredTime.substr(2, 5) + ':' + data.params.cardExpiredTime.substr(7, 2)
              this.cardDetail.cardAllowTimes = data.params.cardAllowTimes
              this.cardDetail.realTimes = data.params.realTimes
              if (data.params.singleFloorAutoRegistration === 0) {
                this.cardDetail.cardAuto = '关闭'
              }
              if (data.params.singleFloorAutoRegistration === 1) {
                this.cardDetail.cardAuto = '开启'
              }

              for (var k in data.params) {
                if (k.indexOf('elevatorNumber') > -1) {
                  liftLen++
                }
              }
              for (let i = 0; i < liftLen; i++) {
                let door = ''
                if (data.params['allowDoor' + (i + 1)] === 0) {
                  door = '前门'
                }
                if (data.params['allowDoor' + (i + 1)] === 1) {
                  door = '后门'
                }
                // 展示显示楼层
                for (let k in this.liftNumberRuleObj) {
                  if (k.toString() === data.params['elevatorNumber' + (i + 1)].toString()) {
                    this.cardDetail.liftList.push({
                      liftNumber: data.params['elevatorNumber' + (i + 1)],
                      floor: this.liftNumberRuleObj[k][Number(data.params['allowFloor' + (i + 1)])],
                      door: door
                    })
                    break
                  }
                }
              }

              this.$http.get(this.$api.user_card_info, {
                params: {
                  orgId: this.villageId,
                  cardNum: this.cardDetail.cardNumber
                }
              }).then((res) => {
                let data = res.data

                if (data.success) {
                  if (data.data === null) {
                    this.cardDetail.id = ''
                    this.cardDetail.ownerId = ''
                    this.cardDetail.userType = '-'
                    this.cardDetail.userName = '-'
                    this.cardDetail.userCard = '-'
                    this.cardDetail.status = -1
                    this.cardDetail.userType = '-'
                    if (data.msg) {
                      this.isVillage = false
                      this.title = '读卡信息(非本小区卡片)'
                    }
                  } else {
                    this.cardDetail.id = data.data.id
                    this.cardDetail.ownerId = data.data.ownerId
                    this.cardDetail.cardNumber = data.data.cardNum
                    this.cardDetail.userType = data.data.userType
                    this.cardDetail.userName = data.data.owner
                    this.cardDetail.userCard = data.data.idNum
                    this.cardDetail.status = data.data.status
                    switch (data.data.userType) {
                      case 0:
                        this.cardDetail.userType = '业主'
                        break
                      case 4:
                        this.cardDetail.userType = '物业保洁'
                        break
                    }
                    this.isVillage = true
                    this.title = '读卡信息'
                  }
                  this.dialog = true
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg,
                    duration: 1000
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$message({
                type: 'error',
                message: '读卡失败',
                duration: 1000
              })
            }
          }
        }
      }
    },
    onFailure () {
      console.log('连接失败')
    },
    cardNotBtn () {
      this.$refs.cardForm.resetFields()
      this.cardForm.id = ''
      this.cardForm.cardSN = ''
      this.cardForm.cardStatus = ''
      this.cardForm.cardSection = ''
      this.cardForm.userType = ''
      this.cardForm.user = ''
      this.cardForm.cardNum = ''
      this.cardForm.cardType = ''
      this.cardForm.allowTimes = ''
      this.cardForm.activeTime = ''
      this.cardForm.autho = ''
      this.cardForm.workTime = ''
      this.cardForm.roomAttr = []
      this.cardForm.selectRoomArr = []
      this.cardForm.isType5 = false
      this.cardForm.cardTypeStatus = false
      this.cardLoading = false
      this.cardDialog = false
      this.$refs.liftList.clearSelection()
    },
    notBtn () {
      this.cardDetail.liftList = []
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.dialog = false
    },
    cardOkBtn () {
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          if (this.cardForm.cardStatus === '在线') {
            this.cardLoading = true
            if (this.cardForm.selectRoomArr.length === 0 && this.cardForm.cardType !== 5) {
              this.$message({
                type: 'error',
                message: '请选择可使用电梯',
                duration: 1000
              })
              this.cardLoading = false
            } else {
              let n = 0 // 电梯排序
              let myRoomList = this.cardForm.selectRoomArr
              let allowTimes = ''
              let effectiveDate = ''
              let expireDate = ''
              let startDate = ''
              let endDate = ''
              let owner = ''
              let rooms = []
              let ownerRoomIds = []
              let floorDoor = []

              if (this.cardForm.allowTimes === '') {
                allowTimes = null
              } else {
                allowTimes = this.cardForm.allowTimes
              }
              if (this.cardForm.activeTime !== '' && this.cardForm.activeTime !== null) {
                effectiveDate = this.$date1(this.cardForm.activeTime[0].toString()) + ' 00:00:00'
                expireDate = this.$date1(this.cardForm.activeTime[1].toString()) + ' 23:59:59'
              }
              if (this.cardForm.workTime !== '' && this.cardForm.workTime !== null) {
                startDate = this.$date5(this.cardForm.workTime[0].toString())
                endDate = this.$date5(this.cardForm.workTime[1].toString())
              }
              for (let i = 0; i < this.cardForm.userList.length; i++) {
                if (this.cardForm.userList[i].id === this.cardForm.user) {
                  owner = this.cardForm.userList[i].name
                  break
                }
              }
              for (let i = 0; i < this.cardForm.selectRoomArr.length; i++) {
                if (this.cardForm.userType === 0) {
                  // 业主
                  rooms.push(this.cardForm.selectRoomArr[i].building + '-' + this.cardForm.selectRoomArr[i].unit + '-' + this.cardForm.selectRoomArr[i].room)
                } else if (this.cardForm.userType === 4) {
                  // 物业保洁
                  rooms.push(this.cardForm.selectRoomArr[i].building + '-' + this.cardForm.selectRoomArr[i].unit)
                }
                ownerRoomIds.push(this.cardForm.selectRoomArr[i].id)
              }
              let myUrl
              if (this.cardForm.id === '') {
                myUrl = this.$api.card_add
              } else {
                myUrl = this.$api.card_edit
              }
              for (let i = 0; i < myRoomList.length; i++) {
                n++
                let groupNum
                if (myRoomList[i].json.groupNum.length === 1) {
                  groupNum = '00' + myRoomList[i].json.groupNum
                } else if (myRoomList[i].json.groupNum.length === 2) {
                  groupNum = '0' + myRoomList[i].json.groupNum
                } else if (myRoomList[i].json.groupNum.length === 3) {
                  groupNum = myRoomList[i].json.groupNum
                }
                if (this.cardForm.userType === 0) {
                  let door = null
                  if (myRoomList[i].json.door === 'front') {
                    door = 0
                  }
                  if (myRoomList[i].json.door === 'back') {
                    door = 1
                  }
                  floorDoor.push({
                    elevator: groupNum,
                    floor: myRoomList[i].json.floor,
                    door: door
                  })
                }
                if (this.cardForm.userType === 4) {
                  floorDoor.push({
                    elevator: groupNum,
                    floor: null,
                    door: null
                  })
                }
              }
              if (n > 12 && this.cardForm.cardType !== 5) {
                this.$message({
                  type: 'error',
                  message: '电梯数量上限为12台',
                  duration: 1000
                })
                this.cardLoading = false
              } else {
                this.$http({
                  method: 'post',
                  url: myUrl,
                  data: {
                    id: this.cardForm.id,
                    orgId: this.villageId,
                    ownerId: this.cardForm.user,
                    cardNum: this.cardForm.cardNum,
                    cardType: this.cardForm.cardType,
                    allowTimes: allowTimes,
                    effectiveDate: effectiveDate,
                    expireDate: expireDate,
                    auth: this.cardForm.autho,
                    userType: this.cardForm.userType,
                    owner: owner,
                    workTime: startDate + '-' + endDate,
                    rooms: rooms.join(),
                    ownerRoomIds: ownerRoomIds,
                    floorDoor: floorDoor
                  }
                }).then((res) => {
                  let data = res.data

                  if (data.success) {
                    this.tempCard = this.cardForm.cardNum
                    this.tempSN = this.cardForm.cardSN
                    this.cardNotBtn()
                    this.client = new window.Paho.MQTT.Client(this.host, Number(this.port), this.clientId)
                    let options = {
                      invocationContext: {
                        host: this.host,
                        port: this.port,
                        path: this.client.path,
                        clientId: this.clientId
                      },
                      useSSL: this.$useSSL,
                      timeout: 10,
                      keepAliveInterval: 60,
                      cleanSession: true,
                      userName: this.username,
                      password: this.password,
                      onSuccess: this.onConnectWrite,
                      onFailure: this.onFailure
                    }
                    this.client.connect(options)
                    this.notBtn()
                  } else {
                    this.$message({
                      type: 'error',
                      message: data.msg,
                      duration: 1000
                    })
                  }
                  this.cardLoading = false
                }).catch((err) => {
                  this.cardLoading = false
                  console.log(err)
                })
              }
            }
          } else {
            this.$message({
              type: 'error',
              message: '写卡器终端处于离线状态',
              duration: 1000
            })
          }
        } else {
          return false
        }
      })
    },
    onConnectWrite () {
      console.log('连接成功')
      this.writeLoading = true
      let flag = true // 连接状态

      this.emqTime = setTimeout(() => {
        this.writeLoading = false
        clearTimeout(this.emqTime)
        this.cardNotBtn()
        flag = false
        this.$message({
          type: 'error',
          message: '连接超时',
          duration: 1000
        })
      }, 10000)

      let subTopic = '/TYPE02/' + this.tempSN + '/reply'
      this.client.subscribe(subTopic, { qos: 1 })

      // 收到消息时调用
      this.client.onMessageArrived = (res) => {
        this.writeLoading = false
        let data = JSON.parse(res.payloadString)
        console.log(data)
        if (flag) {
          if (data.cmd === 'writeResult') {
            if (data.params.cardNumber.toLocaleLowerCase() === this.tempCard.toLocaleLowerCase()) {
              clearTimeout(this.emqTime)
              if (data.params.result === 1) {
                this.$message({
                  message: '写卡成功',
                  type: 'success',
                  duration: 1000
                })
                this.getCardList(this.cardCurr, this.cardSize)
              } else {
                this.$message({
                  type: 'error',
                  message: '写卡失败',
                  duration: 1000
                })
              }
            }
          }
        }
      }
      // 当客户端失去连接时调用
      this.client.onConnectionLost = function (responseObject) {
        if (responseObject.errorCode !== 0) {
          console.log('onConnectionLost:' + responseObject.errorMessage)
        }
      }
    },
    changeUserType (val) {
      this.cardForm.user = ''
      this.cardForm.userList = []
      this.cardForm.roomAttr = []
      this.cardForm.selectRoomArr = []
      this.cardForm.isType5 = false
      // this.$refs.liftList.clearSelection()
      this.cardForm.cardType = ''
      this.cardForm.allowTimes = ''
      this.cardForm.cardTypeStatus = false
      if (this.cardForm.userType === 0) {
        // 获取业主下拉框数据
        this.$http.get(this.$api.owner_select).then((res) => {
          let data = res.data

          if (data.success) {
            this.cardForm.userList = data.data.data
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
        this.cardForm.cardTypeList = [
          {
            key: 1,
            value: '乘梯卡不计次数'
          },
          {
            key: 2,
            value: '乘梯卡计次数'
          },
          {
            key: 3,
            value: '用户保密切换卡'
          },
          {
            key: 6,
            value: '备用'
          }
        ]
      }
      if (this.cardForm.userType === 4) {
        // 获取物业保洁下拉框数据
        this.$http.get(this.$api.orgmanager_list, {
          params: {
            orgId: this.villageId,
            pageSize: 9999,
            pageNum: 1
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.cardForm.userList = data.data.list
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
        this.cardForm.cardTypeList = [
          {
            key: 4,
            value: 'VIP卡'
          },
          {
            key: 5,
            value: '通卡'
          }
        ]
      }
    },
    changeUser (val) {
      this.cardForm.roomAttr = []
      this.cardForm.selectRoomArr = []
      // this.$refs.liftList.clearSelection()
      if (this.cardForm.userType === 0) {
        // 获取业主详情数据
        this.$http.get(this.$api.owner_detail_card, {
          params: {
            ownerId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            // 展示当前小区房间
            for (let i = 0; i < data.data.data.length; i++) {
              if (data.data.data[i].orgId === this.villageId) {
                this.cardForm.roomAttr.push(data.data.data[i])
              }
            }
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.cardForm.userType === 4) {
        // 获取物业保洁详情数据
        this.$http.get(this.$api.orgmanager_building_detail, {
          params: {
            id: val
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.cardForm.roomAttr = data.data.data
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    selectRoom (selection) {
      this.cardForm.selectRoomArr = selection
    },
    changeCardType (val) {
      this.cardForm.allowTimes = ''
      if (val === 5) {
        this.cardForm.isType5 = true
      } else {
        this.cardForm.isType5 = false
      }
    },
    cardCurrChange (curr) {
      this.getCardList(curr, this.cardSize)
    },
    cardSizeChange (size) {
      this.getCardList(this.cardCurr, size)
    },
    getCardType (val) {
      for (let i = 0; i < this.cardTypeList.length; i++) {
        if (val === this.cardTypeList[i].key) {
          return this.cardTypeList[i].value
        }
      }
    },
    getAutho (val) {
      for (let i = 0; i < this.autoList.length; i++) {
        if (val === this.autoList[i].key) {
          return this.autoList[i].value
        }
      }
    },
    getOwnerType (val) {
      for (let i = 0; i < this.userTypeList.length; i++) {
        if (val === this.userTypeList[i].key) {
          return this.userTypeList[i].value
        }
      }
    },
    myTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2)
      }
    },
    set10to16String (str) {
      if (str.length < 2) {
        return '0' + str
      } else {
        return str
      }
    },
    set16to10String (str) {
      if (str.length === 1) {
        return '00' + str
      }
      if (str.length === 2) {
        return '0' + str
      }
      if (str.length === 3) {
        return str
      }
    },
    notData (str) {
      return this.$null(str)
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.cardCurr - 1) * this.cardSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.card
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .time
      float left
      margin-top 8px
      margin-left 20px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
            font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .autho
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
        .userType
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.owner
            background-image url('./owner.png')
          &.tenant
            background-image url('./tenant.png')
          &.propClean
            background-image url('./property.png')
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        .el-select, .el-input, .el-date-editor
          width 240px
        .el-form-item
          &.myItem
            margin-bottom 0
          .title
            display inline-block
            width 100px
            font-size 14px
            color #333
            text-align right
            vertical-align top
          .content
            display inline-block
            font-size 14px
            color #999
            vertical-align top
      .list
        thead
          tr, th
            color #666
            background-color #fafafa
            .cell
              font-weight bold
        tbody
          tr, th
            color #333
        td
          padding 7px 0
        .cell
          line-height 26px
</style>



// WEBPACK FOOTER //
// src/components/card/card.vue